import React, { useEffect, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useParams } from 'react-router-dom';
import ExitTicketThermal from '../reports/components/ExitTicketThermalPrintView';


const PrintTicketPage = () => {
    const { salidaId } = useParams();
    const [html, setHtml] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`/api/salidas/${salidaId}/ticket`)
            .then(async (res) => {
                if (!res.ok) throw new Error(await res.text());
                return res.json();
            })
            .then((data) => {
                const markup = renderToStaticMarkup(<ExitTicketThermal data={data} />);
                setHtml(markup);
            })
            .catch((err) => setError(err.message));
    }, [salidaId]);

    useEffect(() => {
        if (!html) return;
        // Pequeño delay para asegurar que el iframe ya renderizó
        const timer = setTimeout(() => {
            const iframe = document.getElementById('print-frame');
            if (!iframe) return;
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }, 500);
        return () => clearTimeout(timer);
    }, [html]);

    if (error) {
        return (
            <div style={{ padding: 24, fontFamily: 'monospace' }}>
                Error: {error}
            </div>
        );
    }

    if (!html) {
        return (
            <div style={{ padding: 24, fontFamily: 'monospace' }}>
                Cargando ticket...
            </div>
        );
    }

    return (
        <iframe
            id="print-frame"
            title="Ticket de Salida"
            srcDoc={html}
            style={{ width: '100%', height: '100vh', border: 'none' }}
        />
    );
};

export default PrintTicketPage;